import api from './api';

class AccountService {
  async getAccounts() {
    const response = await api.get('/v1/accounts');
    return response.data;
  }

  async getAccount(id) {
    const response = await api.get(`/v1/accounts/${id}`);
    return response.data;
  }

  async getAccountBalance(id) {
    const response = await api.get(`/v1/accounts/${id}/balance`);
    return response.data;
  }

  async createAccount(data) {
    const response = await api.post('/v1/accounts', data);
    return response.data;
  }

  async updateAccount(id, data) {
    const response = await api.put(`/v1/accounts/${id}`, data);
    return response.data;
  }

  async deleteAccount(id) {
    const response = await api.delete(`/v1/accounts/${id}`);
    return response.data;
  }
}

export default new AccountService();
